export class IntroductionConfig {
    isRowView = true;
}
